import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Vollyball = () => {
  return (
    <SportsLayoutComp name={'Vollyball'}/>
  )
}

export default Vollyball